export const reportMappings = [
  {
	"label": "UPC / Barcode",
	"value": "upc",
	"required": true,
	"requiredLabel": true
  },
  {
	"label": "Catalog Number",
	"value": "cat_no",
	"required": true,
	"requiredLabel": true
  },
  {
	"label": "Sales Figure",
	"value": "total_sales",
	"required": false,
	"requiredLabel": true
  },
  {
	"label": "Stock Figure",
	"value": "stock",
	"required": false,
	"requiredLabel": true
  },
  {
	"label": "7 Days Sales (optional)",
	"value": "seven_day_sales",
	"required": false,
	"requiredLabel": false
  }
]